import { render, staticRenderFns } from "./add_tg.vue?vue&type=template&id=db190ace&"
import script from "./add_tg.vue?vue&type=script&lang=js&"
export * from "./add_tg.vue?vue&type=script&lang=js&"
import style0 from "./add_tg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports